<template>
<div class="qa-page-wrap">
  <div class="qaWrap">
    <!-- <div class="qa01">
      <div class="link-wrap" @click="jumpDiscord"></div>
    </div> -->
    <h2>
      <span>常見問题</span>
      <span>Q&A</span>
    </h2>
    <h3>你不懂的問題這裡都有喔～</h3>
    <div class="step-wrap">
      <div class="step-item">
        <h4>申請入駐</h4>
        <h5>1. 如何申请入駐</h5>
        <p>申請入駐已經全面開放啦，APP和電腦端都可以入駐了喔～</p>
        <h5>2. 申請入駐時技能只能申請一項嗎?</h5>
        <p>申請入駐過程中，可以申請一項技能，入駐成功後目前開放的熱門技能都可以申請哦，後續還會開放更多技能，敬請期待!</p>
        <h5>3. 入駐審核需要多久？</h5>
        <p>工作日24小時內會審核完畢喔。!</p>
        <h5>4. 如何知道自己的技能審核通過了呢？</h5>
        <p>技能審核通過後，您會收到官方通知審核通過結果，在App或者網頁的對話圖標可看到系統通知喔~!</p>
      </div>
      <div class="step-item margin65">
        <h4>個人信息設置</h4>
        <h5>1. 個人頁面的設置</h5>
        <p>目前只有app端有個人頁面的設置喔，網頁端只會展示相冊及技能簡介。</p>
      </div>
      <div class="step-item margin65">
        <h4>技能設置</h4>
        <h5>1. 如何申請技能？</h5>
        <p>未入駐的用戶可以點擊“申請入駐”進行首個技能申請，成為陪玩師後可以在“技能管理”處進行技能的添加與修改喔~</p>
        <h5>2. 想修改牌位，要怎麼修改呢?</h5>
        <p>修改牌位需要重新提交一次技能審核喔。</p>
        <h5>3. 為什麼有些人的服務時間是半小時跟一小時?服務時間要怎麼調整？</h5>
        <p>時間單位是根據技能的不同有各自不同的計算方式。EX：端遊英雄聯盟是以一小時為單位，手游傳說對決是以半小時為單位。</p>
      </div>
      <div class="step-item margin45">
        <h4>帳號</h4>
        <h5>1. 換了手機號碼現在收不到驗證碼無法登入帳號？</h5>
        <p>請通過原號碼收取驗證碼，登錄App後自行進行手機帳號更換。</p>
        <h5>2. 請問只能使用手機號碼登入嗎？</h5>
        <p>目前支持多種第三方登入方式，包括 Line, Facebook, Gmail。</p>
      </div>
      <div class="step-item margin65">
        <h4>訂單</h4>
        <h5>1. 該怎麼拒絕已下單的用戶呢？</h5>
        <p>如果臨時有事不能接單的話，陪玩師可以先跟用戶溝通協商，讓用戶取消訂單並申請退款；未取消的訂單在不接單的情況下10分鐘內會自動取消。</p>
        <h5>2. 請問訂單完成要去哪點選</h5>
        <div class="to-person">
          <h3>對於陪玩師：</h3>
          <ul>
            <li>訂單結束時，陪玩師可以點擊完成訂單按鈕。完成後3天內用戶沒有點選完成訂單，將自動完成訂單交易。</li>
            <li>陪玩師完成訂單後3天內，用戶可以向陪玩師申請退款。</li>
            <li>若雙方都沒有點選完成訂單，陪玩師接單後的第30天，系統會自動完成交易。</li>
          </ul>
        </div>
        <div class="to-person">
          <h3>對於用戶：</h3>
          <ul>
            <li>訂單結束時，用戶可以點選完成訂單，陪玩師便不能向用戶提出退款</li>
            <li>若認為服務有疑慮，用戶可申請退款，若陪玩師未在24小時回覆，退款則自動成立；若陪玩師否決退款，7天內會完成該次訂單交易。</li>
            <li>若雙方都沒有點選完成訂單，陪玩師接單後的第30天，系統會自動完成交易。</li>
          </ul>
        </div>
        <h5>4. 下單付款成功後進行退款，錢會什麼時候到帳呢</h5>
      <p>若認為服務有疑慮，用戶可申請退款，若陪玩師未在24小時回覆，退款則自動成立；若陪玩師否決退款，7天內會完成該次訂單交易。若雙方都沒有點選完成訂單，會在訂單完成開始30天後完成訂單交易。</p>
      </div>
      <div class="step-item margin65">
        <h4>新人優惠專區</h4>
        <h5>1. 什麼是新人優惠券？</h5>
        <p>新人優惠券是nicee為新註冊用戶準備的福利！用25元優惠券在新人優惠專區給陪玩師下單時使用喔~</p>
      </div>
      <div class="step-item margin65">
        <h4>提領</h4>
        <h5>1. 陪玩師的收益怎麼抽成？</h5>
        <p>陪玩師的收益，每單抽成20%。</p>
        <h5>2. 如何提領？什麼時候能到帳？</h5>
        <p>目前提領僅提供在電腦端進行操作喔~最低提領金額是3000。申請的提領，會在七個工作日到帳。台灣以外的陪玩師提領時可選擇paypal方式進行提領。</p>
      </div>
      <div class="step-item margin65">
        <h4>儲值</h4>
        <h5>1. 儲值方式</h5>
        <p>目前網頁版可以透過銀行轉帳、信用卡、超商代碼等方式喔。App只能透過蘋果或是google商店進行儲值，應用商店在儲值時會額外收取一定費用，非平台的額外抽成。</p>
        <h5>2. 海外陪玩師可以如何進行儲值？</h5>
        <p>海外陪玩師目前僅支持VISA進行儲值。</p>
      </div>
    </div>
    <p>～～想玩就約我呦～～</p>
  </div>
  <div class="qaWarp-moblie">
    <!-- <div class="qa01">
      <div class="link-wrap" @click="jumpDiscord"></div>
    </div> -->
    <h2>
      <span>常見問题</span>
      <span>Q&A</span>
    </h2>
    <h3>你不懂的問題這裡都有喔～</h3>
    <div class="step-wrap">
      <div class="step-item">
        <h4>申請入駐</h4>
        <h5>1. 如何申请入駐</h5>
        <p>申請入駐已經全面開放啦，APP和電腦端都可以入駐了喔～</p>
        <h5>2. 申請入駐時技能只能申請一項嗎?</h5>
        <p>申請入駐過程中，可以申請一項技能，入駐成功後目前開放的熱門技能都可以申請哦，後續還會開放更多技能，敬請期待!</p>
        <h5>3. 入駐審核需要多久？</h5>
        <p>工作日24小時內會審核完畢喔。!</p>
        <h5>4. 如何知道自己的技能審核通過了呢？</h5>
        <p>技能審核通過後，您會收到官方通知審核通過結果，在App或者網頁的對話圖標可看到系統通知喔~!</p>
      </div>
      <div class="step-item margin45">
        <h4>個人信息設置</h4>
        <h5>1. 個人頁面的設置</h5>
        <p>目前只有app端有個人頁面的設置喔，網頁端只會展示相冊及技能簡介。</p>
      </div>
      <div class="step-item margin45">
        <h4>技能設置</h4>
        <h5>1. 如何申請技能？</h5>
        <p>未入駐的用戶可以點擊“申請入駐”進行首個技能申請，成為陪玩師後可以在“技能管理”處進行技能的添加與修改喔~</p>
        <h5>2. 想修改牌位，要怎麼修改呢?</h5>
        <p>修改牌位需要重新提交一次技能審核喔。</p>
        <h5>3. 為什麼有些人的服務時間是半小時跟一小時?服務時間要怎麼調整？</h5>
        <p>時間單位是根據技能的不同有各自不同的計算方式。EX：端遊英雄聯盟是以一小時為單位，手游傳說對決是以半小時為單位。</p>
      </div>
      <div class="step-item margin45">
        <h4>帳號</h4>
        <h5>1. 換了手機號碼現在收不到驗證碼無法登入帳號？</h5>
        <p>請通過原號碼收取驗證碼，登錄App後自行進行手機帳號更換。</p>
        <h5>2. 請問只能使用手機號碼登入嗎？</h5>
        <p>目前支持多種第三方登入方式，包括 Line, Facebook, Gmail。</p>
      </div>
      <div class="step-item margin45">
        <h4>訂單</h4>
        <h5>1. 該怎麼拒絕已下單的用戶呢？</h5>
        <p>如果臨時有事不能接單的話，陪玩師可以先跟用戶溝通協商，讓用戶取消訂單並申請退款；未取消的訂單在不接單的情況下10分鐘內會自動取消。</p>
        <h5>2. 請問訂單完成要去哪點選</h5>
        <div class="to-person">
          <h3>對於陪玩師：</h3>
          <ul>
            <li>訂單結束時，陪玩師可以點擊完成訂單按鈕。完成後3天內用戶沒有點選完成訂單，將自動完成訂單交易。</li>
            <li>陪玩師完成訂單後3天內，用戶可以向陪玩師申請退款。</li>
            <li>若雙方都沒有點選完成訂單，陪玩師接單後的第30天，系統會自動完成交易。</li>
          </ul>
        </div>
        <div class="to-person">
          <h3>對於用戶：</h3>
          <ul>
            <li>訂單結束時，用戶可以點選完成訂單，陪玩師便不能向用戶提出退款</li>
            <li>若認為服務有疑慮，用戶可申請退款，若陪玩師未在24小時回覆，退款則自動成立；若陪玩師否決退款，7天內會完成該次訂單交易。</li>
            <li>若雙方都沒有點選完成訂單，陪玩師接單後的第30天，系統會自動完成交易。</li>
          </ul>
        </div>
        <h5>4. 下單付款成功後進行退款，錢會什麼時候到帳呢</h5>
      <p>若認為服務有疑慮，用戶可申請退款，若陪玩師未在24小時回覆，退款則自動成立；若陪玩師否決退款，7天內會完成該次訂單交易。若雙方都沒有點選完成訂單，會在訂單完成開始30天後完成訂單交易。</p>
      </div>
      <div class="step-item margin45">
        <h4>新人優惠專區</h4>
        <h5>1. 什麼是新人優惠券？</h5>
        <p>新人優惠券是nicee為新註冊用戶準備的福利！用25元優惠券在新人優惠專區給陪玩師下單時使用喔~</p>
      </div>
      <div class="step-item margin45">
        <h4>提領</h4>
        <h5>1. 陪玩師的收益怎麼抽成？</h5>
        <p>陪玩師的收益，每單抽成20%。</p>
        <h5>2. 如何提領？什麼時候能到帳？</h5>
        <p>目前提領僅提供在電腦端進行操作喔~最低提領金額是3000。申請的提領，會在七個工作日到帳。台灣以外的陪玩師提領時可選擇paypal方式進行提領。</p>
      </div>
      <div class="step-item margin45">
        <h4>儲值</h4>
        <h5>1. 儲值方式</h5>
        <p>目前網頁版可以透過銀行轉帳、信用卡、超商代碼等方式喔。App只能透過蘋果或是google商店進行儲值，應用商店在儲值時會額外收取一定費用，非平台的額外抽成。</p>
        <h5>2. 海外陪玩師可以如何進行儲值？</h5>
        <p>海外陪玩師目前僅支持VISA進行儲值。</p>
      </div>
    </div>
    <p>～～想玩就約我呦～～</p>
  </div>
</div>

</template>

<script>
export default {
  methods: {
    jumpDiscord() {
      window.open('https://discord.gg/mQXuq5e')
    }
  }
}
</script>

<style lang="scss" scoped>
.margin65{
  margin-top: 65px;
}
.margin45{
  margin-top: 45px;
}
.to-person{
  margin-top: 10px;
  h3{
    font-weight: 500;
    text-indent: 1px;
    font-feature-settings: 'liga' off;
    color: #333333;
  }
  li{
    text-indent: 1px;
    font-feature-settings: 'liga' off;
    color: #666666;
    list-style-type: disc;
    word-break: break-all;
  }
}
.step-wrap{
  background: #ffffff;
  border-radius: 20px;
}
.step-item{
  >h4{
    margin-top: 0;
    font-weight: 600;
    color: #333333;
  }
  h5{
    font-weight: 500;
    color: #333333;
  }
  p{
    margin-top: 10px;
    color: #666666;
    word-break: break-all;
  }
}
@media screen and (min-width:600px) {
  .to-person{
    margin-top: 10px;
    h3{
      font-size: 18px;
      line-height: 25px;
    }
    li{
      margin-top: 15px;
      font-size: 18px;
      line-height: 25px;
      margin-left: 40px;
    }
    li:nth-of-type(1){
      margin-top: 10px;
    }
  }
  .step-item{
    h5:nth-of-type(1){
      margin-top: 40px;
    }
    >h4{
      font-size: 32px;
      line-height: 45px;
    }
    h5{
      margin-top: 45px;
      font-size: 24px;
      line-height: 34px;
    }
    p{
      font-size: 18px;
      line-height: 25px;
    }
  }
  .step-wrap{
    margin: 100px 20px 0;
    padding: 40px 40px 90px;
    border: 10px solid #333333;
  }
  .qaWrap {
    height: 3967px;
    background: url('./qaImages/qaPC.png') no-repeat center;
    background-size: 100%;
    margin: 40px auto;
    line-height: 0;
    display: flex;
    flex-direction: column;
    >h2{
      text-align: center;
      margin-top: 100px;
      span{
        font-style: normal;
        font-weight: bold;
        font-size: 72px;
        line-height: 101px;
        color: #FE7F38;
      }
      span:nth-of-type(2){
        margin-left: 25px;
      }
    }
    >h3{
      text-align: center;
      margin-top: 15px;
      font-style: normal;
      font-weight: normal;
      font-size: 42px;
      line-height: 59px;
      color: #000000;
    }
    >p{
      margin-top: 100px;
      text-align: center;
      font-weight: bold;
      font-size: 42px;
      line-height: 59px;
      color: #333333;
    }
    .qa01 {
      width:100%;
      position: relative;
    }
    .link-wrap {
      width: 300px;
      height: 20px;
      position: absolute;
      top: 670px;
      left: 700px;
      cursor: pointer;
    }
  }
  .qaWarp-moblie {
    display: none;
  }
}
@media screen and (max-width:599px) {
  .to-person{
    margin-top: 10px;
    h3{
      font-size: 14px;
      line-height: 20px;
    }
    li{
      margin-top: 10px;
      font-size: 14px;
      line-height: 20px;
      margin-left: 16px;
    }
  }
  .step-item{
    >h4{
      font-size: 24px;
      line-height: 34px;
    }
    h5{
      margin-top: 25px;
      font-size: 18px;
      line-height: 25px;
    }
    p{
      font-size: 14px;
      line-height: 20px;
    }
  }
  .step-wrap{
    margin: 50px 18px 0;
    padding: 27px 17px 37px;
    border: 3px solid #333333;
  }
  .qaWrap {
    display: none;
  }
  .qa-page-wrap{
    margin-bottom: 52px!important;
  }
  .qaWarp-moblie {
    width: 100vw;
    height: 3350px;
    line-height: 0;
    display: flex;
    flex-direction: column;
    background: url('./qaImages/qaMobile.png') no-repeat center;
    background-size: 100%;
    .qa01 {
      position: relative;
      .link-wrap {
        width: 300px;
        height: 20px;
        position: absolute;
        top: 56%;
        left: 40px;
        cursor: pointer;
      }
    }
    >h2{
      text-align: center;
      margin-top: 50px;
      span{
        font-style: normal;
        font-weight: bold;
        font-size: 28px;
        line-height: 39px;
        color: #FE7F38;
      }
      span:nth-of-type(2){
        margin-left: 8px;
      }
    }
    >h3{
      text-align: center;
      margin-top: 6px;
      font-style: normal;
      font-weight: normal;
      font-size: 18px;
      line-height: 25px;
      color: #000000;
    }
    >p{
      margin-top: 50px;
      text-align: center;
      font-weight: bold;
      font-size: 18px;
      line-height: 25px;
      color: #333333;
    }
  }
}
</style>
